import { LayerDefinition } from './types';

export const seeingDefinition: LayerDefinition = {
  id: 'seeing',
  name: 'Astronomical Seeing',
  category: 'forecast',
  categoryLabel: 'Specialized Forecast Index',
  icon: '🔭',
  description: 'Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.',
  sourceModels: ['rdps', 'hrrr', 'rrfs', 'gfs', 'ecmwf', 'icon13'],
  outputModels: ['rdps & hrrr .pmtiles'],
  config: {
    defaultModel: 'rdps'
  }
};

export default seeingDefinition;
